import cn from "classnames";

import { Blocks } from "@/components/blocks/blocks.component";
import { Price } from "@/components/price/price.component";

import { brown } from "@/app/font";

export const SalesPrice = ({
  quantity,
  listPrice,
  listPriceClassName,
  salesPrice,
  salesPriceClassName,
  className,
  reverse,
  free,
  freeText = "FREE",
  loading,
  loadingLines = 1,
  loadingClassName,
  monthly = false,
  ...rest
}: PriceProps) => {
  // Check loading state
  if (loading) {
    return <Blocks blocks={loadingLines} className={loadingClassName} />;
  }
  if (!listPrice && !salesPrice) return null;
  if (!salesPrice) salesPrice = listPrice;
  // Determine if prices are equal or if sales price is better
  const pricesAreEqual = salesPrice && listPrice === salesPrice;
  const isBetterPrice = listPrice && salesPrice && listPrice > salesPrice;
  return (
    <div
      data-testid="sales-price"
      {...rest}
      className={cn(className, "flex items-center gap-1", {
        "flex-row-reverse": reverse,
        "flex-row": !reverse,
      })}>
      <Price
        data-testid="sales-price-sale-price"
        value={salesPrice}
        free={free}
        freeText={freeText}
        monthly={monthly}
        className={cn(salesPriceClassName, {
          [`${brown.className} headline-6 whitespace-nowrap`]:
            !salesPriceClassName,
        })}
      />
      {!pricesAreEqual && isBetterPrice ? (
        <Price
          data-testid="sales-price-list-price"
          value={listPrice}
          monthly={monthly}
          className={cn(listPriceClassName, {
            "whitespace-nowrap line-through": !listPriceClassName,
          })}
        />
      ) : null}
    </div>
  );
};

export type PriceProps = {
  className?: string;
  quantity?: number;
  listPriceClassName?: string;
  salesPrice?: number | null;
  salesPriceClassName?: string;
  listPrice?: number | null;
  reverse?: boolean;
  free?: boolean;
  freeText?: string;
  loading?: boolean;
  loadingLines?: number;
  loadingClassName?: string;
  monthly?: boolean;
};
